/* Shared design tokens for the CoBrain page + sub-components.
   Mirrors the homepage cream theme. */

export const PALETTE = {
  bg: "#F8F4EC",
  bgAlt: "#F5F0E4",
  ink: "#1a1a1a",
  ink2: "#3a3530",
  muted: "#5a5249",
  amber: "#C4823A",
  amberSoft: "#E8B458",
  line: "rgba(0,0,0,0.08)",
  card: "#FFFFFF",
  dark: "#171513",
} as const;

export const FONT_BODY = "Barlow, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif";
export const FONT_DISPLAY = "'Instrument Serif', 'Cormorant Garamond', Georgia, serif";
export const FONT_MONO = "'JetBrains Mono', ui-monospace, monospace";

export const CALENDLY = "https://calendly.com/electricsheephq/30min?utm_source=cobrain";

/* Lightweight analytics helper. Pushes to dataLayer if present,
   otherwise no-op (debug log in dev). Never throws. */
export function track(event: string, payload?: Record<string, unknown>) {
  try {
    const w = window as any;
    w.dataLayer = w.dataLayer || [];
    w.dataLayer.push({ event: `cobrain.${event}`, ...payload });
    if (import.meta.env.DEV) {
      // eslint-disable-next-line no-console
      console.debug(`[cobrain] ${event}`, payload || {});
    }
  } catch {
    /* noop */
  }
}

/* (icons live in icons.tsx — keep this file pure TS) */